import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewDetachIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="viewDetach" ref={ref} {...props}>
      <path d="M16.08,2.54H6.29A3.75,3.75,0,0,0,2.54,6.29v10A3.75,3.75,0,0,0,6.29,20H9.86a.7.7,0,0,0,.25-.05.75.75,0,0,0,.5-.7,8.48,8.48,0,0,1,8.47-8.47.76.76,0,0,0,.75-.75V6.29A3.75,3.75,0,0,0,16.08,2.54Zm-6.94,16H6.29A2.25,2.25,0,0,1,4,16.29v-10A2.25,2.25,0,0,1,6.29,4h9.79a2.25,2.25,0,0,1,2.25,2.25V9.34A10,10,0,0,0,9.14,18.54Zm11.65-6.2A8.66,8.66,0,0,0,12.14,21a.17.17,0,0,0,0,.07.13.13,0,0,0,0,.06.64.64,0,0,0,.2.4.7.7,0,0,0,.54.24h4.89A3.76,3.76,0,0,0,21.54,18V13.09A.75.75,0,0,0,20.79,12.34ZM20,18a2.25,2.25,0,0,1-2.25,2.25H13.68A7.15,7.15,0,0,1,20,13.88Z" />
    </Icon>
  ),
) as IconWithRender;

ViewDetachIcon.displayName = 'ViewDetachIcon';
ViewDetachIcon.renderIcon = (props) => <ViewDetachIcon {...props} />;
export default ViewDetachIcon;
